(function () {
  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.getElementById('MobileMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
      // Keep the whole menu reachable on short screens: it scrolls inside the remaining height
      menu.style.maxHeight = open ? '' : (window.innerHeight - menu.getBoundingClientRect().top) + 'px';
    });
    // Close the menu when the screen becomes desktop width (e.g. a tablet is rotated)
    var desktop = window.matchMedia('(min-width: 990px)');
    var onDesktop = function (e) {
      if (e.matches && toggle.getAttribute('aria-expanded') === 'true') toggle.click();
    };
    if (desktop.addEventListener) desktop.addEventListener('change', onDesktop);
    else if (desktop.addListener) desktop.addListener(onDesktop);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') toggle.click();
    });
  }

  // Header shadow once scrolled
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Sticky offsets: the menu tabs sit right under the sticky header, and anchor jumps land below both
  var root = document.documentElement;
  var setOffsets = function () {
    if (header) {
      var wrap = header.parentElement;
      var sticky = wrap && getComputedStyle(wrap).position === 'sticky';
      var height = header.offsetHeight;
      if (menu && !menu.hidden) height -= menu.offsetHeight;
      root.style.setProperty('--header-height', (sticky ? height : 0) + 'px');
    }
    document.querySelectorAll('.menu-tabs').forEach(function (bar) {
      bar.parentElement.style.setProperty('--tabs-height', bar.offsetHeight + 'px');
    });
  };
  setOffsets();
  window.addEventListener('resize', setOffsets);

  // Highlight today in every opening-hours table
  var today = new Date().getDay();
  document.querySelectorAll('.hours tr[data-day="' + today + '"]').forEach(function (row) {
    row.classList.add('is-today');
  });

  // "Nu open / Nu gesloten" badge, parsed from strings like "09:00 – 17:30"
  var hours = window.themeHours;
  var badge = document.querySelector('[data-open-badge]');
  if (hours && badge) {
    var match = (hours.days[today] || '').match(/(\d{1,2})[:.](\d{2})\D+(\d{1,2})[:.](\d{2})/);
    var isOpen = false;
    if (match) {
      var now = new Date();
      var mins = now.getHours() * 60 + now.getMinutes();
      var start = +match[1] * 60 + +match[2];
      var end = +match[3] * 60 + +match[4];
      isOpen = mins >= start && mins < end;
    }
    var label = document.createElement('strong');
    label.textContent = (isOpen ? hours.openLabel : hours.closedLabel) + ' · ';
    badge.insertBefore(label, badge.children[1]);
    badge.classList.add(isOpen ? 'is-open' : 'is-closed');
  }

  // Menu category tabs: mark the active one while scrolling
  var tabs = document.querySelectorAll('.menu-tabs__link');
  if (tabs.length && 'IntersectionObserver' in window) {
    var byId = {};
    var lockUntil = 0;
    var setActive = function (tab) {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      // On small screens the tab row scrolls sideways: bring the active tab into view
      var bar = tab.parentElement;
      if (bar.scrollWidth > bar.clientWidth) {
        bar.scrollTo({ left: tab.offsetLeft - (bar.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
      }
    };
    tabs.forEach(function (t) {
      byId[t.getAttribute('href').slice(1)] = t;
      // A clicked tab stays active while the page scrolls to it (two columns can pass another category on the way)
      t.addEventListener('click', function () { lockUntil = Date.now() + 1200; setActive(t); });
    });
    var io = new IntersectionObserver(function (entries) {
      if (Date.now() < lockUntil) return;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var tab = byId[entry.target.id];
        if (tab) setActive(tab);
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    Object.keys(byId).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) io.observe(el);
    });
  }
})();

// Deal of the week/month: pick the deal that is valid today in the visitor's browser.
// Liquid already picked one, but Shopify may serve a cached page after the date changed.
// Uses Amsterdam time (the shop's day), with the device clock as fallback.
(function () {
  function todayKey() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
      var key = parseInt(parts.replace(/\D/g, ''), 10);
      if (key > 20000101) return key;
    } catch (e) { /* fall back to the device clock */ }
    var d = new Date();
    return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  }

  function pickDeal(section) {
    var deals = section.querySelectorAll('[data-deal]');
    var today = todayKey();
    var active = null;
    var bestStart = -1;
    var bestEnd = 99991231;
    deals.forEach(function (deal) {
      if (deal.hasAttribute('data-unreadable')) return;
      var start = parseInt(deal.getAttribute('data-start'), 10) || 0;
      var end = parseInt(deal.getAttribute('data-end'), 10) || 99991231;
      if (start > today || today > end) return;
      // Same rule as the Liquid: latest start wins, then the one that ends first, then the first slot
      if (start > bestStart || (start === bestStart && end < bestEnd)) {
        active = deal;
        bestStart = start;
        bestEnd = end;
      }
    });
    deals.forEach(function (deal) { deal.hidden = deal !== active; });
    section.hidden = !active && section.getAttribute('data-hide-empty') === 'true';
  }

  // In the theme editor, keep what Liquid rendered (it shows an overview for the owner)
  if (window.Shopify && window.Shopify.designMode) return;
  document.querySelectorAll('[data-deal-section]').forEach(pickDeal);
})();
